/**
 * AssessFlowStepper — read-only 4-step progress header for the 1-2-1 take flow
 * (Phase 3). Mirrors the verbal-preview AssessmentStepper:
 *   ["Choose scale", "Survey", "Conversation", "Baseline report"]
 *
 * Pure presentation — the active step is supplied by the caller.
 */
import React from "react";
import { Step, StepLabel, Stepper } from "@mui/material";

export const ASSESS_FLOW_STEPS = ["Choose scale", "Survey", "Conversation", "Baseline report"] as const;

type AssessFlowStepperProps = {
    /** Zero-based index of the active step. */
    activeStep: number;
};

export const AssessFlowStepper = ({ activeStep }: AssessFlowStepperProps): JSX.Element => (
    <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 4 }}>
        {ASSESS_FLOW_STEPS.map((label) => (
            <Step key={label}>
                <StepLabel>{label}</StepLabel>
            </Step>
        ))}
    </Stepper>
);
